/**
 * A constant that determines if the current environment is a browser.
 * It checks if the `window` object is defined.
 *
 * @constant {boolean}
 */
export const isBrowser = typeof window !== 'undefined';
